import React, { FC, useContext, useCallback } from 'react';

import styled from 'styled-components';
import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../../store';

import AppModal from '../../../../../components/Modal';
import Button from '../../../../../components/Button';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';
import { px } from '../../../../../contrib/ui';

interface IProps {
  isOpen: boolean;
  toggleOpen: () => void;
}

const InvitePlayersConfirmationModal: FC<IProps> = props => {
  const { isOpen, toggleOpen } = props;

  const { adminEvents } = useContext(GlobalContext);
  const { clubId, eventId } = useRouteInfoState();

  const goToDashboard = () => navigate(`/staff/club/${clubId}`);

  const goToRound = useCallback(() => {
    if (eventId) {
      const event = adminEvents[Number(eventId)];
      const round = event.rounds[0];

      navigate(`/staff/club/${clubId}/event/${eventId}/round/${round.id}/setup`);
    }
  }, [eventId, adminEvents, clubId]);

  return (
    <Modal
      id="club15-help-modal"
      open={isOpen}
      onClose={toggleOpen}
      title="SUCCESS. INVITES SENT."
      actions={[
        <Button
          key="button-cancel"
          onClick={goToDashboard}
          variant="outlined"
          color="primary"
          fullWidth={true}
        >
          GO TO CLUB DASHBOARD
        </Button>,
        <Button
          key="button-agree"
          onClick={goToRound}
          variant="contained"
          color="primary"
          fullWidth={true}
        >
          SETUP ROUND 1
        </Button>
      ]}
    />
  );
};

export default InvitePlayersConfirmationModal;

const Modal = styled(AppModal)`
  .modal-actions {
    button {
      max-width: fit-content !important;
      width: fit-content !important;
      span.button__label {
        width: ${px(350)};
      }
    }
  }
`;
